<!-- <div class="list-container">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">Customer Product Price List</h4>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">Customer</th>
                        <th scope="col">Product</th>
                        <th scope="col">Uom</th>
                        <th scope="col">Min Qty</th>
                        <th scope="col">Max Qty</th>
                        <th scope="col">Per Unit Price</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let list of customerProductPriceList | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber1,
                        totalItems: totalRecords
                        };let i = index">
                        <td scope="col">{{list.customerName}} ( {{list.customerId}} )</td>
                        <td scope="col">{{list.productName}} ( {{list.productId}} )</td>
                        <td scope="col">{{list.uom}}</td>
                        <td scope="col">{{list.minQty}}</td>
                        <td scope="col">{{list.maxQty}}</td>
                        <td scope="col">{{list.perUnitPrice}}</td>
                        <th scope="col">
                            <span>
                                <i  data-toggle="modal" data-target="#viewDepartment" class="bi bi-eye-fill"></i>
                            </span>
                        </th>
                    </tr>
                </tbody>
            </table>
            <div class="pagination-block" *ngIf="customerProductPriceList.length != 0">
                <pagination-controls
                    previousLabel="Prev"
                    nextLabel="Next"
                    (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
            </div>
        </div>
    </div>
</div>
     -->




     <div class="profile-container">
        <div class="">
            <div class="profile-content">    
                <div class="personal-details">
    
                    <div class="header-block">
                        <div class="header-title">
                            <p>Customer Product Price List</p>
                        </div>
                        <div class="add-block">
                            <div class="search">
                                <form autocomplete="off" >
                                    <input type="text" placeholder="search">
                                </form>
                                <i class="bi bi-search" ></i>
                            </div>
                            <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
                        </div>
                    </div>
    
                    <table class="table table-striped">
                        <thead>
                            <tr>
                            <th style="width: 20%;">Customer</th>
                            <th style="width: 20%;">Product</th>
                            <th style="width: 10%;text-align: center;">Uom</th>
                            <th style="width: 10%;text-align: center;">Min Qty</th>
                            <th style="width: 10%;text-align: center;">Max Qty</th>
                            <th style="width: 15%;text-align: center;">Per Unit Price</th>
                            <th style="width: 15%;text-align: center;padding: 0;" class="">Action</th>
                            </tr>
                        </thead>
                    </table>
                    <div *ngIf="!isLoading">
                        <div class="data-view" *ngFor="let list of customerProductPriceList | paginate : {
                            itemsPerPage: tableSize,
                            currentPage: pageNumber,
                            totalItems: totalRecords
                            }  ;let i = index">
    
                            <p style="width: 20%;">{{list.customerName}} ( {{list.customerId}} )</p>
                            <p style="width: 20%;">{{list.productName}} ( {{list.productId}} )</p>
                            <p style="width: 10%;text-align: center;">{{list.uom}}</p>
                            <p style="width: 10%;text-align: center;">{{list.minQty}}</p>
                            <p style="width: 10%;text-align: center;">{{list.maxQty}}</p>
                            <p style="width: 15%;text-align: center;">{{list.perUnitPrice}}</p>
                        
                            <p class="action-buttons" style="width: 15%;padding-left: 25px;">
                                <i *ngIf="actionControls.isModify" class="bi bi-pencil-square" (click)="getCustomerProductPriceByCustomerProductPriceId(list.customerProductPriceId)" data-toggle="modal" data-target="#editModal" ></i>
                                <i *ngIf="actionControls.isDelete" class="bi bi-trash3" (click)="deleteIdSelect(list.id)" data-toggle="modal" data-target="#deleteModal"></i>
                            </p>
                        </div>
                    </div>
    
    
                    <div class="loader" *ngIf="isLoading">
                        <div class="spinner"></div>
                    </div>
    
                    <div class="loader"  *ngIf="!isLoading && customerProductPriceList.length == 0">
                        <div class="no-data">
                            <img src="assets/no-data-6.png" alt="">
                            <p>no data found</p>
                        </div>
                        
                    </div>
    
                    <div class="paginator">
                        <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                        [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                        </p-paginator>
                    </div>
    
    
                </div>
            </div>
        </div>
    </div>

<div class="modal fade" id="viewDepartment" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Department Details
                    <span data-dismiss="modal">
                        <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                        </svg>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div>
                    
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Add Customer Product Price
            <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </span>
          </h5>
        </div>
        <div class="modal-body">
            <div [formGroup]="addCustomerProductPriceForm">
                <div class="row">
                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <label>Product <span class="required-field">*</span></label>
                            <div >
                                <p-dropdown 
                                [style]="{'minWidth':'100%'}"
                                [options]="products" 
                                [(ngModel)]="selectedProduct" 
                                placeholder="select a product" 
                                [editable]="false"
                                [filter]="true"
                                [ngModelOptions]="{standalone: true}"
                                optionLabel="name"></p-dropdown>
                            </div>

                        </div>
                        <div class="form-group">
                            <label>Customer <span class="required-field">*</span></label>
                            <div >
                                <p-multiSelect 
                                [style]="{'minWidth':'100%'}"
                                [options]="customers" 
                                [(ngModel)]="selectedCustomers" 
                                placeholder="select a customers" 
                                [ngModelOptions]="{standalone: true}"
                                optionLabel="name"></p-multiSelect>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>UOM <span class="required-field">*</span></label>
                            <div >
                                <p-dropdown 
                                [style]="{'minWidth':'100%'}"
                                [options]="uoms" 
                                [(ngModel)]="selectedUOM" 
                                placeholder="select a uom" 
                                [editable]="false"
                                [filter]="true"
                                [ngModelOptions]="{standalone: true}"
                                optionLabel="uomName"></p-dropdown>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Min Qty <span class="required-field">*</span></label>
                            <input formControlName="minQty" type="text" class="form-control">
                            <span class="err" *ngIf="addCustomerProductPriceForm.get('minQty').invalid && formSubmit">min qty required</span>
                        </div>
                        <div class="form-group">
                            <label>Max Qty <span class="required-field">*</span></label>
                            <input formControlName="maxQty" type="text" class="form-control">
                            <span class="err" *ngIf="addCustomerProductPriceForm.get('maxQty').invalid && formSubmit">department name required</span>
                        </div>
                        <div class="form-group">
                            <label>Per Unit Price <span class="required-field">*</span></label>
                            <input formControlName="perUnitPrice" type="text" class="form-control">
                            <span class="err" *ngIf="addCustomerProductPriceForm.get('perUnitPrice').invalid && formSubmit">per unit price required</span>
                        </div>
                    </div>


                    
               
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Cancel</button>

                <button type="button" (click)="addCustomerProductPrice()" class="btn btn-primary">Submit</button>
            </div>
        </div>
      </div>
    </div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
                    <span data-dismiss="modal">
                        <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                        </svg>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>are you sure? want to delete??</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="deleteDepartmentInfo()" class="btn btn-primary">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>





<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">Edit Customer Product Price
                    <span data-dismiss="modal">
                        <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                        </svg>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="editCustomerProductPriceForm">
                    <div class="row">
                        <div class="col-md-12 col-lg-12">
                            <div class="form-group">
                                <label>Product <span class="required-field">*</span></label>
                                <input readonly formControlName="productName" type="text" class="form-control readonly">
    
    
                            </div>
                            <div class="form-group">
                                <label>Customer <span class="required-field">*</span></label>
                                <input readonly formControlName="customerName" type="text" class="form-control readonly">
    
                            </div>
                            <div class="form-group">
                                <label>UOM <span class="required-field">*</span></label>
                                <input readonly formControlName="uom" type="text" class="form-control readonly">
    
                            </div>
                            <div class="form-group">
                                <label>Min Qty <span class="required-field">*</span></label>
                                <input formControlName="minQty" type="text" class="form-control">
                                <span class="err" *ngIf="editCustomerProductPriceForm.get('minQty').invalid && formSubmit">min qty required</span>
                            </div>
                            <div class="form-group">
                                <label>Max Qty <span class="required-field">*</span></label>
                                <input formControlName="maxQty" type="text" class="form-control">
                                <span class="err" *ngIf="editCustomerProductPriceForm.get('maxQty').invalid && formSubmit">department name required</span>
                            </div>
                            <div class="form-group">
                                <label>Per Unit Price <span class="required-field">*</span></label>
                                <input formControlName="perUnitPrice" type="text" class="form-control">
                                <span class="err" *ngIf="editCustomerProductPriceForm.get('perUnitPrice').invalid && formSubmit">per unit price required</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" id="closeModalButton3" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="editCustomerProductPrice()" class="btn btn-primary">Edit</button>
                </div>
            </div>
        </div>
    </div>
</div>